
const moduleData = {
  id: "module-7",
  title: "Module 7",
  subtitle: "Applying Karma Yoga in professional life to earn righteously and intensify desire for liberation (Puruṣarthas)",
   cardImage: "/enBanner/m7_banner.jpg",
  pdfPath: "/en/Modules/m7.pdf",
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/m7.mp3",
    duration: "0:00"
  },
  video: {
    id: "s-y_2_Q-2_Q"
  },
  hero: {
    title: "Module 7",
    subtitle: "Applying Karma Yoga in professional life to earn righteously and intensify desire for liberation (Puruṣarthas)",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m7_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What is Applying Karma Yoga in professional life to earn righteously and intensify desire for liberation (Puruṣarthas)?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
          {
            question: "According to Swami, what should be the attitude towards worldly activities?",
            options: ["They should be avoided", "They should be done with love and as an offering to God", "They should be done for personal gain", "They should be done without any dedication"],
            answer: "They should be done with love and as an offering to God"
          },
          {
            question: "What does the Bhagavad Gita proclaim as the royal road to perfection?",
            options: ["Nishkama karma", "Bhakti yoga", "Raja yoga", "Karma yoga"],
            answer: "Nishkama karma"
          },
          {
            question: "What is the true sadhana (spiritual discipline)?",
            options: ["Meditating daily", "Doing one's duty sincerely", "Attending religious ceremonies", "Reading scriptures"],
            answer: "Doing one's duty sincerely"
          },
          {
            question: "What type of food is considered Sathwik (pure)?",
            options: ["Food with too much salt or pepper", "Uncooked raw pulses, nuts, and fruits", "Fried and spicy food", "Food with high fat and starch content"],
            answer: "Uncooked raw pulses, nuts, and fruits"
          },
          {
            question: "What should be combined with business according to Swami?",
            options: ["Wealth", "Morality", "Power", "Fame"],
            answer: "Morality"
          },
          {
            question: "According to the method, one should ensure that every word spoken is true, necessary, and will not hurt others.",
            options: ["True", "False"],
            answer: "True"
          },
          {
            question: "Thrishna (thirst) is different from desire and has no limit.",
            options: ["True", "False"],
            answer: "True"
          },
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
